import { types, actions } from './requests'
export const UPDATEMACHINETYPE_TYPES = {
    ...types('UPDATEMACHINETYPE'),
}
export const UPDATEMACHINETYPE_ACTIONS = {
    ...actions('UPDATEMACHINETYPE'),
}
